import { ref } from '@nuxtjs/composition-api';

const showModal = ref(false)
const modalData = ref(null)
const partnerName = ref(null)

export default function usePlayInfoModal () {
  const openModal = (service, name) => {
    showModal.value = true
    modalData.value = service
    partnerName.value = name
  }
  const closeModal = () => {
    showModal.value = false
    modalData.value = null
    partnerName.value = null
  }
  return {
    partnerName,
    showModal,
    modalData,
    openModal,
    closeModal
  }
}
